var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6663 5.30409L23.6557 10.6668H19.6183C19.093 10.6668 18.6663 10.1588 18.6663 9.53342V5.30409ZM26.321 9.77075L20.3943 3.10408C20.1423 2.82541 19.7837 2.66675 19.4077 2.66675H8.74101C6.86101 2.66675 5.33301 4.16275 5.33301 6.00008V26.0001C5.33301 27.8374 6.86101 29.3334 8.74101 29.3334H23.2583C25.1383 29.3334 26.6663 27.8374 26.6663 26.0001V10.6667C26.6663 10.3347 26.5437 10.0161 26.321 9.77075Z",
    fill: "#85C7F6"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 22,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6663 5.30409L23.6557 10.6668H19.6183C19.093 10.6668 18.6663 10.1588 18.6663 9.53342V5.30409ZM26.321 9.77075L20.3943 3.10408C20.1423 2.82541 19.7837 2.66675 19.4077 2.66675H8.74101C6.86101 2.66675 5.33301 4.16275 5.33301 6.00008V26.0001C5.33301 27.8374 6.86101 29.3334 8.74101 29.3334H23.2583C25.1383 29.3334 26.6663 27.8374 26.6663 26.0001V10.6667C26.6663 10.3347 26.5437 10.0161 26.321 9.77075Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file.874f858a.svg";
export { ForwardRef as ReactComponent };